import React, { FC, HTMLAttributes, useCallback, useMemo, useRef } from 'react';
import classNames from 'classnames';
import { Field, useField } from 'react-final-form';
import { FileUploadWrapper } from 'components/forms';
import { Note } from 'components/ui';
import { FileInfo } from 'components';
import { t } from 'utils';

import styles from './PackageUpload.module.scss';

export interface IPackageUpload extends HTMLAttributes<HTMLDivElement> {
  name: string;
  disabled?: boolean;
}

const PackageUpload: FC<IPackageUpload> = (props) => {
  const { name, className, disabled } = props;
  const {
    input: { value, onChange },
  } = useField(name);
  const fileInput = useRef<HTMLInputElement>();

  const info = useMemo(() => {
    if (!value) return { fileName: '', fileSize: '0' };
    const { name: fileName, size }: { name: string; size: number } = value[0];
    const fileSize = (size / 2 ** 20).toFixed(2);
    return { fileName, fileSize };
  }, [value]);

  const handleFileRemove = useCallback(() => {
    if (!fileInput.current) return;
    fileInput.current.value = '';
    onChange('');
  }, [onChange]);

  const rootClassName = classNames(styles.root, className, { [styles.disabled]: !!disabled });
  return (
    <div className={rootClassName}>
      <Field
        className='mb-2'
        name={name}
        label='app.preview.overview.package.label'
        placeholder='app.preview.overview.package.placeholder'
        component={FileUploadWrapper}
        disabled={disabled}
        ref={fileInput}
        maxFiles={1}
      />
      <Note className={styles.note}>{t('app.preview.overview.package.hintText')}</Note>
      {value && (
        <FileInfo filename={info.fileName} size={info.fileSize} onRemove={handleFileRemove} />
      )}
    </div>
  );
};

export default PackageUpload;
